export const nl = {
  AanhefBewindvoerderCurator: "Aanhef",
  AanmeldFormulierIndienen: "Aanmeldformulier indienen",
  Achternaam: "Achternaam",
  AdresWijzigingDoorgeven: "Adreswijziging doorgeven",
  AchternaamBewindvoerderCurator: "Achternaam bewindvoerder of curator",
  AndereVraagOfOpmerking: "Heeft u andere vragen of opmerkingen?",
  AutomatischeIncassoAanvragen: "Automatische incasso aanvragen",
  AutomatischeIncassoStopzetten: "Wilt u de automatische incasso stopzetten?",
  BankrekeningnummerWijzigen: "Bankrekeningnummer wijzigen",
  BestaatUit10DigitsTekst:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het veld moet 10 cijfers bevatten.",
  BetalingsregelingAanvragen: "Betalingsregeling facturen Wmo vanaf 2020",
  BerekeningEigenbijdrage: "Berekening eigen bijdrage",
  BerekeningVanMijnEigenBijdrage: "Berekening van mijn eigen bijdrage",
  BetalingsRegelingAantalTermijnen: "In hoeveel termijnen wilt u het openstaande bedrag betalen?",
  BetalingsRegelingAantalTermijnenInfoText: "Als wij vragen hebben hierover, nemen wij contact met u op.",
  BetalingsRegelingAantalTermijnenMinValue:
    "U heeft het invulveld 'In hoeveel termijnen wilt u het openstaande bedrag betalen?' niet juist ingevuld. Het aantal termijnen moet minstens 1 zijn.",
  BevestigingEmail: "Wilt u een bevestiging op uw e-mailadres ontvangen?",
  BewindvoerdersCuratorenContactFormulier: "Bewindvoerders en curatoren",
  BewindvoerdersOverigeRegelingenBestandenInfoText:
    "Voeg een kopie toe van het besluit van de rechter waaruit blijkt dat u als bewindvoerder of curator bent aangesteld.",
  Bericht: "Bericht",
  BsnValidationFactoryText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het burgerservicenummer bestaat uit 9 cijfers.",
  BurgerServiceNummerClient: "Burgerservicenummer (BSN) cliënt",
  BurgerServiceNummerToelichting: `Gaat uw vraag/verzoek over uw persoonlijke dossier bij het CAK? Vul dan uw burgerservicenummer
  en geboortedatum in. Daarmee kunnen wij uw vraag sneller en beter beantwoorden.`,
  Bijlage: "Bijlage",
  bijlagen: "bijlagen",
  Bijlagen: "Bijlage(n)",
  BijlageFileIndicatorLabel: "Bijlage",
  BijlageInfoText: "Maximaal 5 bijlagen, maximaal 5 MB per bijlage.",
  BijlageToevoegen: "Bijlage toevoegen",
  BijlageToevoegenButton: "Bijlage toevoegen",
  CakKenmerk: "Kenmerk CAK",
  CAKKenmerkInfoText: "Het CAK ID-nummer, kenmerk, referentie van de brief of het zaaknummer van uw cliënt.",
  ClientInCurateelEnBewindRegister: "Staat uw cliënt in het centraal curatele- en bewindregister?",
  Contactformulier: "Contactformulier",
  ContactFormulierFormulierStapMijnVraag: "Mijn vraag",
  DateNotInFutureValidationFactoryText:
    "U heeft in het invulveld '{{label}}' een toekomstige datum ingevuld.",
  DateValidationFactoryValidationText: "U heeft in het invulveld '{{label}}' geen juiste datum ingevuld.",
  DeHeer: "De heer",
  DocumentenAanvragen: "Documenten aanvragen",
  DocumentOfFormulierDigitaalOpsturen: "Document of formulier digitaal opsturen",
  EenVraagStellen: "Een vraag stellen",
  EenWijzigingDoorgeven: "Een wijziging doorgeven",
  EigenBijdrageAutomatischBetalen: "Eigen bijdrage automatisch betalen",
  EmailAdres: "E-mailadres",
  EmailAdresInfoTxt: "Wij gebruiken dit e-mailadres als wij contact met u willen opnemen over uw bericht.",
  ErKunnenMaximaalAantalTekensIngevoerdWorden: "Er kunnen maximaal {{aantal}} tekens ingevoerd worden.",
  FileMaxSizeValidationText:
    "U heeft in het invulveld '{{label}}' meer dan de maximaal toegestane bestandsgrootte geüpload, bijlagen mogen maximaal 5MB zijn.",
  FileMaxSizeValidationTextAlternative:
    "'{{label}}' is groter dan de maximaal toegestane bestandsgrootte, bijlagen mogen maximaal 5MB zijn.",
  FileMaxNumberOfAttachmentsValidationText:
    "U heeft in het invulveld '{{label}}' meer dan het toegestane aantal bijlagen geüpload, u mag maximaal {{maxFiles}} {{bijlagen}} uploaden.",
  GeboorteDatum: "Geboortedatum (dd-mm-jjjj)",
  GeboorteDatumClient: "Geboortedatum cliënt (dd-mm-jjjj)",
  HeeftUAndereVragenOfOpmerkingen: "Heeft u andere vragen of opmerkingen?",
  Huisnummer: "Huisnummer",
  IetsAnders: "Iets anders",
  Inleiding: "Inleiding",
  IntegerValidationText: "U heeft het invulveld '{{label}}' niet juist ingevuld. Het is geen geldig getal.",
  IsDecimalValidationText: "U heeft het invulveld '{{label}}' niet juist ingevuld. Het is geen geldig getal.",
  Ja: "Ja",
  KenmerkCAK: "Kenmerk CAK",
  KenmerkCAKInfoTxt: "Uw CAK ID-nummer, kenmerk of referentie van de brief, uw zaaknummer.",
  KenmerkCAKToelichting: `Gaat uw vraag/verzoek over uw persoonlijke dossier bij het CAK? Vul dan uw Kenmerk CAK en
  geboortedatum in. Daarmee kunnen wij uw vraag sneller en beter beantwoorden.`,
  KlachtenFormulier: "Klachtenformulier",
  KlachtFormulierStapMijnKlacht: "Mijn klacht",
  KlachtFormulierStapInleiding: "Inleiding",
  KlantnummerInfoTxt: "Het klantnummer vindt u op de factuur, rechts naast het blauwe blokje.",
  KopieVanBeschikkingOntvangen: "Wilt u een kopie van de beschikking ontvangen?",
  KopieVanBeschikkingJaar: "Van welk jaar wilt u de beschikking ontvangen?",
  Land: "Land",
  Mevrouw: "Mevrouw",
  MijnGegevens: "Mijn gegevens",
  NaamClient: "Naam cliënt",
  NaamKantoor: "Naam kantoor",
  Nee: "Nee",
  OmschrijfUwVraag: "Omschrijf uw vraag",
  OverzichtOpenstaandeFacturenOntvangen: "Wilt u een overzicht van de openstaande facturen ontvangen?",
  OpenstaandSaldoOpvragen: "Openstaand saldo opvragen",
  PlaatsNaam: "Plaatsnaam",
  Postcode: "Postcode",
  MeldingNoteerNummerVoorVerzending:
    "Noteer het nummer dat verschijnt na het versturen. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MeldingNoteerNummerNaVerzending:
    "Noteer bovenstaand nummer. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  Omschrijving: "Omschrijving",
  OmWelkeRegelingGaatHet: "Over welke regeling gaat het",
  OverWelkeRegelingGaatHet: "Over welke regeling gaat het?",
  Regeling: "Regeling",
  RegelingOndersteuningVanuitWmo: "Ondersteuning vanuit de Wmo",
  RegelingZorgVanuitDeWlz: "Zorg vanuit de Wlz",
  RegelingZorgverzekeringEnBuitenland: "Zorgverzekering en buitenland",
  RegelingMedicijnenMeeOpReis: "Medicijnen mee op reis",
  RegelingOnverzekerden: "Regeling onverzekerden",
  RegelingBetalingsachterstandZorgpremie: "Betalingsachterstand zorgpremie",
  RegelingGemoedsbezwaarden: "Regeling gemoedsbezwaarden",
  RekeningnummerIBAN: "Rekeningnummer (IBAN)",
  RekeningnummerIBANAutomatischeIncassoStopzetten:
    "Voor welk rekeningnummer (IBAN) wilt u de automatische incasso stopzetten?",
  RekeningNummerDoorgeven: "Wilt u het rekeningnummer van uw cliënt doorgeven?",
  RekeningNummerDoorgevenInfoText:
    "Op dit rekeningnummer kunnen wij eventueel bedragen terugbetalen. Bijvoorbeeld bij een aanpassing van de eigen bijdrage.",
  Straatnaam: "Straatnaam",
  Telefoonnummer: "Telefoonnummer",
  Toelichting: "Toelichting",
  UBent: "U bent",
  UBentProfessioneelBewindvoerderOfCurator: "Professioneel bewindvoerder of curator",
  UBentBewindvoerderOfCuratorVoorEenFamilielidOfBekende:
    "Bewindvoerder of curator voor een familielid of bekende",
  UBentWSNPBewindvoerderOfCuratorBijFaillissement: "WSNP-bewindvoerder of curator bij faillissement",
  VerplichtVeldIsNietIngevuldTijdensVerzenden: "Verplicht veld is niet ingevuld tijdens verzenden",
  Voorletters: "Voorletters",
  VoorlettersBewindvoerderCurator: "Voorletter(s) bewindvoerder of curator",
  VoorIemandAnders: "Voor iemand anders die klant is bij het CAK.",
  VoorMijzelf: "Voor mijzelf. Ik ben klant bij het CAK.",
  WaarGaatUwVraagOver: "Waar gaat uw vraag over?",
  WatWiltUDoen: "Wat wilt u doen?",
  WelkBedragMaximaalAflossen: "Welk bedrag kunt u per maand maximaal missen?",
  WiltUBetalingsRegelingAanvragenVoorClient: "Wilt u een betalingsregeling aanvragen?",
  WiltUNieuweClientAanmelden: "Wilt u een nieuwe cliënt aanmelden?",
  WSNPBewindvoerderOfCuratorBijFaillissement: "Bent u WSNP-bewindvoerder of curator bij faillissement?",
  ZorgVanuitDeWlz: "Zorg vanuit de Wlz",
  Post: "Post",
  Email: "E-mail",
  AvgFormulier: "Avg formulier",
  AvgFormulierStapMijnRecht: "Mijn verzoek",
  AvgFormulierStapInleiding: "Inleiding",
  AvgRechtInzien: "Ik wil mijn gegevens inzien",
  AvgRechtWijzigen: "Ik wil mijn gegevens wijzigen",
  AvgRechtVerwijderen: "Ik wil mijn gegevens laten verwijderen",
  AvgRechtBeperken: "Ik wil dat jullie bepaalde gegevens van mij niet gebruiken"
};
